import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { DilysuAilgyfeirioComponent } from "./modiwlau/dilysu/dilysu-ailgyfeirio/dilysu-ailgyfeirio.component";
import { GuardsService } from "./craidd/gwasanaethau/guard/guards.service";
import { AnghywirComponent } from "./modiwlau/ui/anghywir/anghywir.component";
import { Rol } from "./craidd/modelau/defnyddiwr/rol";
import { GuardsRolService } from "./craidd/gwasanaethau/guard/guards-rol.service";
import { GuardsHawlModiwlService } from "./craidd/gwasanaethau/guard/guards-hawl-modiwl.service";
import { Modiwl } from "./craidd/modelau/system/modiwl";
import { AllgofnodiAilgyfeirioComponent } from "./modiwlau/dilysu/allgofnodi-ailgyfeirio/allgofnodi-ailgyfeirio.component";
import { LocalizeParser, LocalizeRouterModule, LocalizeRouterSettings, ManualParserLoader } from "@gilsdav/ngx-translate-router";
import { Location } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";
import { AdroddProblemComponent } from "./modiwlau/ui/adrodd-problem/adrodd-problem.component";

export const routes: Routes = [
  {
    path: "",
    loadChildren: () => import("./modiwlau/cartref/cartref.module").then((mod) => mod.CartrefModule),
    canActivate: [GuardsService, GuardsRolService, GuardsHawlModiwlService],
    data: {
      rol: Rol.Defnyddiwr,
      modiwl: Modiwl.Cartref,
    },
  },
  {
    path: "cartref",
    loadChildren: () => import("./modiwlau/cartref/cartref.module").then((mod) => mod.CartrefModule),
    canActivate: [GuardsService, GuardsRolService, GuardsHawlModiwlService],
    data: {
      rol: Rol.Defnyddiwr,
      modiwl: Modiwl.Cartref,
    },
  },
  {
    path: "archeb",
    loadChildren: () => import("./modiwlau/archeb/archeb.module").then((mod) => mod.ArchebModule),
    canActivate: [GuardsService, GuardsRolService, GuardsHawlModiwlService],
    data: {
      rol: Rol.Defnyddiwr,
      modiwl: Modiwl.Archeb,
    },
  },
  {
    path: "opsiwn",
    loadChildren: () => import("./modiwlau/opsiwn/opsiwn.module").then((mod) => mod.OpsiwnModule),
    canActivate: [GuardsService, GuardsRolService],
    data: {
      rol: Rol.Gweinyddwr,
    },
  },
  {
    path: "cerbyd",
    loadChildren: () => import("./modiwlau/cerbyd/cerbyd.module").then((mod) => mod.CerbydModule),
    canActivate: [GuardsService, GuardsRolService, GuardsHawlModiwlService],
    data: {
      rol: Rol.Defnyddiwr,
      modiwl: Modiwl.Cerbyd,
    },
  },
  {
    path: "gyrrwr",
    loadChildren: () => import("./modiwlau/gyrrwr/gyrrwr.module").then((mod) => mod.GyrrwrModule),
    canActivate: [GuardsService, GuardsRolService, GuardsHawlModiwlService],
    data: {
      rol: Rol.UwchWeinyddwr,
      modiwl: Modiwl.Gyrrwr,
    },
  },
  {
    path: "gwaith",
    loadChildren: () => import("./modiwlau/gwaith/gwaith.module").then((mod) => mod.GwaithModule),
    canActivate: [GuardsService, GuardsRolService, GuardsHawlModiwlService],
    data: {
      rol: Rol.Mecanig,
      modiwl: Modiwl.Gwaith,
    },
  },
  {
    path: "gwirio",
    loadChildren: () => import("./modiwlau/gwirio/gwirio.module").then((mod) => mod.GwirioModule),
    canActivate: [GuardsService, GuardsRolService, GuardsHawlModiwlService],
    data: {
      rol: Rol.Defnyddiwr,
      modiwl: Modiwl.Gwirio,
    },
  },
  {
    path: "diogelwch",
    loadChildren: () => import("./modiwlau/diogelwch/diogelwch.module").then((mod) => mod.DiogelwchModule),
    canActivate: [GuardsService, GuardsRolService, GuardsHawlModiwlService],
    data: {
      rol: Rol.Defnyddiwr,
      modiwl: Modiwl.Diogelwch,
    },
  },
  {
    path: "storfa",
    loadChildren: () => import("./modiwlau/storfa/storfa.module").then((mod) => mod.StorfaModule),
    canActivate: [GuardsService, GuardsRolService, GuardsHawlModiwlService],
    data: {
      rol: Rol.Defnyddiwr,
      modiwl: Modiwl.Storfa,
    },
  },
  {
    path: "cyflenwr",
    loadChildren: () => import("./modiwlau/cyflenwr/cyflenwr.module").then((mod) => mod.CyflenwrModule),
    canActivate: [GuardsService, GuardsRolService, GuardsHawlModiwlService],
    data: {
      rol: Rol.Defnyddiwr,
      modiwl: Modiwl.Cyflenwr,
    },
  },
  {
    path: "stoc",
    loadChildren: () => import("./modiwlau/stoc/stoc.module").then((mod) => mod.StocModule),
    canActivate: [GuardsService, GuardsRolService, GuardsHawlModiwlService],
    data: {
      rol: Rol.Defnyddiwr,
      modiwl: Modiwl.Stoc,
    },
  },
  {
    path: "amserlennu",
    loadChildren: () => import("./modiwlau/amserlennu/amserlennu.module").then((mod) => mod.AmserlennuModule),
    canActivate: [GuardsService, GuardsRolService, GuardsHawlModiwlService],
    data: {
      rol: Rol.Defnyddiwr,
      modiwl: Modiwl.Amserlennu,
    },
  },
  {
    path: "tracio",
    loadChildren: () => import("./modiwlau/tracio/tracio.module").then((mod) => mod.TracioModule),
    canActivate: [GuardsService, GuardsRolService, GuardsHawlModiwlService],
    data: {
      rol: Rol.Defnyddiwr,
      modiwl: Modiwl.Tracio,
    },
  },
  {
    path: "dyroddiad",
    loadChildren: () => import("./modiwlau/dyroddiad/dyroddiad.module").then((mod) => mod.DyroddiadModule),
    canActivate: [GuardsService, GuardsRolService, GuardsHawlModiwlService],
    data: {
      rol: Rol.Defnyddiwr,
      modiwl: Modiwl.DogfenDyroddiad,
    },
  },
  {
    path: "adroddiad",
    loadChildren: () => import("./modiwlau/adroddiad/adroddiad.module").then((mod) => mod.AdroddiadModule),
    canActivate: [GuardsService, GuardsRolService, GuardsHawlModiwlService],
    data: {
      rol: Rol.Defnyddiwr,
      modiwl: Modiwl.Adroddiad,
    },
  },
  {
    path: "uwchlwytho",
    loadChildren: () => import("./modiwlau/data/data.module").then((mod) => mod.DataModule),
    canActivate: [GuardsService, GuardsRolService, GuardsHawlModiwlService],
    data: {
      rol: Rol.Gweinyddwr,
      modiwl: Modiwl.Data,
    },
  },
  {
    path: "defnyddiwr",
    loadChildren: () => import("./modiwlau/defnyddiwr/defnyddiwr.module").then((mod) => mod.DefnyddiwrModule),
    canActivate: [GuardsService, GuardsRolService],
    data: {
      rol: Rol.UwchWeinyddwr,
    },
  },
  {
    path: "iaith",
    loadChildren: () => import("./modiwlau/iaith/iaith.module").then((mod) => mod.IaithModule),
    canActivate: [GuardsService, GuardsRolService],
    data: {
      rol: Rol.UwchWeinyddwr,
    },
  },
  {
    path: "bwletin",
    loadChildren: () => import("./modiwlau/bwletin/bwletin.module").then((mod) => mod.BwletinModule),
    canActivate: [GuardsService, GuardsRolService, GuardsHawlModiwlService],
    data: {
      rol: Rol.Mecanig,
      modiwl: Modiwl.Cerbyd,
    },
  },
  {
    path: "damwain",
    loadChildren: () => import("./modiwlau/damwain/damwain.module").then((mod) => mod.DamwainModule),
    canActivate: [GuardsService, GuardsRolService, GuardsHawlModiwlService],
    data: {
      rol: Rol.Defnyddiwr,
      modiwl: Modiwl.Cerbyd,
    },
  },
  {
    path: "dilysu-ailgyfeirio",
    component: DilysuAilgyfeirioComponent,
    data: { skipRouteLocalization: true },
  },
  {
    path: "dilysuailgyfeirio",
    component: DilysuAilgyfeirioComponent,
    data: { skipRouteLocalization: true },
  },
  {
    path: "signin-callback",
    component: DilysuAilgyfeirioComponent,
  },
  {
    path: "allgofnodi-ailgyfeirio",
    component: AllgofnodiAilgyfeirioComponent,
    data: { skipRouteLocalization: true },
  },
  {
    path: "adrodd-problem",
    component: AdroddProblemComponent,
    canActivate: [GuardsService],
  },
  {
    path: "cymorth",
    component: AdroddProblemComponent,
    canActivate: [GuardsService],
  },
  {
    path: "**",
    redirectTo: "/404",
  },
  {
    path: "404",
    component: AnghywirComponent,
    canActivate: [GuardsService],
    data: { codGwall: "404" },
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {}),
    LocalizeRouterModule.forRoot(routes, {
      parser: {
        provide: LocalizeParser,
        useFactory: (translate: TranslateService, location: Location, settings: LocalizeRouterSettings) => new ManualParserLoader(translate, location, settings, ["cy", "en"], "llwybr.", "!"),
        deps: [TranslateService, Location, LocalizeRouterSettings],
      },
    }),
  ],
  exports: [RouterModule, LocalizeRouterModule],
})
export class AppRoutingModule {}
